var exports = {
  "q": "Item__qMjYnv",
};

module.exports = exports;
